import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateWrapper = function __privateWrapper(obj, member, setter, getter) {
  return {
    set _(value) {
      __privateSet(obj, member, value, setter);
    },

    get _() {
      return __privateGet(obj, member, getter);
    }

  };
};

var _range, _startTime, _previousTime, _deltaTime, _frameCount, _updateTimestamp, _updateStartValue, _lastRangeIncrease, _id, _animate;

var RangeAnimation = /*#__PURE__*/function () {
  function RangeAnimation(range, callback, fps) {
    var _this = this;

    _classCallCheck(this, RangeAnimation);

    __privateAdd(this, _range, void 0);

    __privateAdd(this, _startTime, void 0);

    __privateAdd(this, _previousTime, void 0);

    __privateAdd(this, _deltaTime, void 0);

    __privateAdd(this, _frameCount, void 0);

    __privateAdd(this, _updateTimestamp, void 0);

    __privateAdd(this, _updateStartValue, void 0);

    __privateAdd(this, _lastRangeIncrease, void 0);

    __privateAdd(this, _id, 0);

    __privateAdd(this, _animate, function () {
      var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();

      __privateSet(_this, _id, requestAnimationFrame(__privateGet(_this, _animate)));

      __privateSet(_this, _deltaTime, performance.now() - __privateGet(_this, _previousTime));

      var fpsInterval = 1e3 / _this.fps;

      if (__privateGet(_this, _deltaTime) > fpsInterval) {
        __privateSet(_this, _previousTime, now - __privateGet(_this, _deltaTime) % fpsInterval);

        var _fps = 1e3 / ((now - __privateGet(_this, _startTime)) / ++__privateWrapper(_this, _frameCount)._);

        var delta = (now - __privateGet(_this, _updateTimestamp)) / 1e3 / _this.duration;

        var value = __privateGet(_this, _updateStartValue) + delta * _this.playbackRate;

        var increase = value - __privateGet(_this, _range).valueAsNumber;

        if (increase > 0) {
          __privateSet(_this, _lastRangeIncrease, _this.playbackRate / _this.duration / _fps);
        } else {
          __privateSet(_this, _lastRangeIncrease, 0.995 * __privateGet(_this, _lastRangeIncrease));

          value = __privateGet(_this, _range).valueAsNumber + __privateGet(_this, _lastRangeIncrease);
        }

        _this.callback(value);
      }
    });

    __privateSet(this, _range, range);

    this.callback = callback;
    this.fps = fps;
  }

  _createClass(RangeAnimation, [{
    key: "start",
    value: function start() {
      if (__privateGet(this, _id) !== 0) return;

      __privateSet(this, _previousTime, performance.now());

      __privateSet(this, _startTime, __privateGet(this, _previousTime));

      __privateSet(this, _frameCount, 0);

      __privateGet(this, _animate).call(this);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (__privateGet(this, _id) === 0) return;
      cancelAnimationFrame(__privateGet(this, _id));

      __privateSet(this, _id, 0);
    }
  }, {
    key: "update",
    value: function update(_ref) {
      var start = _ref.start,
          duration = _ref.duration,
          playbackRate = _ref.playbackRate;

      var increase = start - __privateGet(this, _range).valueAsNumber;

      if (increase > 0 || increase < -0.03) {
        this.callback(start);
      }

      __privateSet(this, _updateStartValue, start);

      __privateSet(this, _updateTimestamp, performance.now());

      this.duration = duration;
      this.playbackRate = playbackRate;
    }
  }]);

  return RangeAnimation;
}();

_range = new WeakMap();
_startTime = new WeakMap();
_previousTime = new WeakMap();
_deltaTime = new WeakMap();
_frameCount = new WeakMap();
_updateTimestamp = new WeakMap();
_updateStartValue = new WeakMap();
_lastRangeIncrease = new WeakMap();
_id = new WeakMap();
_animate = new WeakMap();
export { RangeAnimation };